import React from 'react'
import { Link } from "gatsby"

const Logo = () => {
    return (
        <div>
            <Link to="/">
                <h1 className="text-2xl font-bold tracking-tighter text-teal-600 uppercase dark:text-teal-400">mattt.pw</h1>
            </Link>
        </div>
    )
}

export default Logo
